export default __webpack_public_path__ + "img/1_11-7478c56d.png";